import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetUtranCellsLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetLastUtranCellsDate`
});

export const GetUtranSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetUtranSites`
});

export const RunCpichValidationRequest = (sites, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/RunCpichValidation`,
	params: { sites, userId }
});

export const GetCpichValidationTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetCpichValidationHistory`
});

export const GetCpichValidationExportRequest = (cpichValidationId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetCpichValidationExport`,
	params: { cpichValidationId }
});
